import React, {useState} from 'react';

import {hooks} from '../hooks';
import {Routes} from '../routes';
import {svg} from '../assets/svg';
import {PartnersType} from '../types';
import {components} from '../components';
import {actions} from '../store/actions';

export const DetailPartners: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();

  const partner: PartnersType = location.state.partner;

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        showBasket={true}
        title='Partner'
      />
    );
  };

  const renderImage = (): JSX.Element => {
    return (
      <section style={{position: 'relative', marginBottom: 30}}>
        <img
          src={partner.img}
          alt={partner.title}
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </section>
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section className='container'>
        <div
          className='row-center-space-between'
          style={{marginBottom: 12}}
        >
          <h3
            className='number-of-lines-1'
            style={{textTransform: 'capitalize'}}
          >
            {partner.title}
          </h3>
        </div>
        <p className='t14'>{partner.description}</p>
      </section>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable' style={{paddingTop: 10, paddingBottom: 20}}>
        {renderImage()}
        {renderDetails()}
      </main>
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
